const Loader = ({ color = "black" }: { color?: string }) => {
  return (
    <div
      className="h-4 w-4 ms-5 rounded-full border-2 border-transparent border-t-2 animate-spin mx-auto"
      style={{
        borderTopColor: color,
      }}
    />
  );
};
export default Loader;
